import * as React from "react";
import OpQuotesHeadingMob from "../partials/opQuotesHeadingMob";
import OpMarketDepthList from "../partials/opMarketDepthList";
import "../../../../../assets/scss/components/toc/orderPlacement/opQuotes/opQuotesMob.scss";
import { IOpQuotesHeadingDskProps } from "../partials/opQuotesHeadingDsk";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesNfoMobProps {
	quoteData: any;
	quoteDataExtra: any;
}

const OpQuotesNfoMob: React.FC<IOpQuotesNfoMobProps> = props => {
	const [showMarketDepth, setShowMarketDepth] = React.useState(false);

	const quotesHeadingProps: IOpQuotesHeadingDskProps = {
		dpNm: props.quoteDataExtra.Name,
		dateRange: `${moment(props.quoteDataExtra.OpenDate).format("DD MMM")} - ${moment(props.quoteDataExtra.CloseDate).format("DD MMM")}`
	};

	return (
		<div className="quotes_cont">
			<OpQuotesHeadingMob {...quotesHeadingProps} />

			<div className="quotes_cont_row m_2">
				<button className="blue_btn" onClick={() => setShowMarketDepth(true)}>
					Market Depth
				</button>
			</div>

			{showMarketDepth && (
				<>
					<div className="popup_overlay" onClick={() => setShowMarketDepth(false)} />
					<div className="popup">
						<div className="popup_header">
							<span>Market Depth</span>
							<button className="edel-icon-close" onClick={() => setShowMarketDepth(false)} />
						</div>
						<OpMarketDepthList
							data={[
								{ label: "Fund Class", value: "Equity" },
								{ label: "Min Investment", value: toINR(props.quoteData.MinPurAmt) },
								{ label: "Entry Load", value: props.quoteDataExtra.EntryLoad || "NA" },
								{ label: "Lock in Period", value: props.quoteDataExtra.LockinPeriod || "NA" },
								{ label: "Risk", value: props.quoteDataExtra.RiskCategory || "NA" }
							]}
						/>
					</div>
				</>
			)}
		</div>
	);
};

export default OpQuotesNfoMob;
